import { motion } from 'framer-motion';
import { useI18n } from '../context/I18nContext';
import { WaitlistForm } from './WaitlistForm';

export const FinalCTA = () => {
  const { t } = useI18n();

  return (
    <section id="waitlist" className="relative py-16 sm:py-24 md:py-32 bg-background overflow-hidden" data-testid="final-cta-section">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] sm:w-[600px] h-[300px] sm:h-[400px] bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-blue-500/10 via-transparent to-transparent" />
      <div className="relative max-w-2xl mx-auto px-4 sm:px-6 md:px-12 text-center">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <h2 className="font-heading text-2xl sm:text-4xl md:text-5xl font-semibold tracking-tight text-foreground mb-4 sm:mb-5" data-testid="final-cta-title">{t('final_cta.title')}</h2>
          <p className="text-muted-foreground text-base sm:text-lg mb-8 sm:mb-10 max-w-lg mx-auto" data-testid="final-cta-subtitle">{t('final_cta.subtitle')}</p>
          <div className="max-w-md mx-auto">
            <WaitlistForm variant="large" />
          </div>
        </motion.div>
      </div>
    </section>
  );
};
